import { mergeStyleSets } from "@fluentui/react";

export const UnAuthorizedStyles = mergeStyleSets({
  unauthorizedHeader: {  
    color: 'red'   
  }
  
});

